var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3C13.17 3 14.505 6.24 12.63 8.13C10.74 10.005 7.5 8.67 7.5 6C7.5 5.20435 7.81607 4.44129 8.37868 3.87868C8.94129 3.31607 9.70435 3 10.5 3ZM8.25 10.5H12.75C13.5456 10.5 14.3087 10.8161 14.8713 11.3787C15.4339 11.9413 15.75 12.7044 15.75 13.5V21.75H13.5V33H7.5V21.75H5.25V13.5C5.25 12.7044 5.56607 11.9413 6.12868 11.3787C6.69129 10.8161 7.45435 10.5 8.25 10.5ZM31.5 12H22.5V15H31.5M31.5 16.5H27V19.5H31.5M31.5 3H22.5V6H31.5M31.5 7.5H27V10.5H31.5M31.5 21H22.5V24H31.5M31.5 30H22.5V33H31.5M31.5 25.5H27V28.5H31.5",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.26cc98c0876c39e7c361ba0b1d5ea5f5.svg";
export { ForwardRef as ReactComponent };